export default __webpack_public_path__ + "static/media/profile-03.58d511cb.png";